const EXIT_BUTTON_ID = 'hdv-demo-exit-btn'
const RESUME_BUTTON_ID = 'hdv-demo-resume-btn'
const ACTIONS_ID = 'hdv-demo-actions'
const DEMO_BANNER_HEIGHT = '28px'

const ensureStyles = () => {
    let style = document.getElementById('hdv-demo-exit-styles')
    if (!style) {
        style = document.createElement('style')
        style.id = 'hdv-demo-exit-styles'
        document.head.appendChild(style)
    }

    style.textContent = `
        #${ACTIONS_ID} {
            position: fixed;
            right: 20px;
            bottom: 20px;
            z-index: 100000;
            display: flex;
            flex-direction: column;
            gap: 8px;
            align-items: stretch;
        }
        #${EXIT_BUTTON_ID},
        #${RESUME_BUTTON_ID} {
            border: 0;
            border-radius: 10px;
            padding: 12px 16px;
            color: #fff;
            font-size: 13px;
            font-weight: 600;
            box-shadow: 0 8px 24px rgba(15, 35, 60, 0.28);
            cursor: pointer;
        }
        #${EXIT_BUTTON_ID} {
            background: #d64545;
            color: #fff;
        }
        #${EXIT_BUTTON_ID}:hover,
        #${EXIT_BUTTON_ID}:focus,
        #${EXIT_BUTTON_ID}:active {
            background: #d64545;
            color: #fff;
        }
        #${RESUME_BUTTON_ID} {
            background: #44bb52;
            color: #fff;
            display: none;
        }
        #${RESUME_BUTTON_ID}:hover,
        #${RESUME_BUTTON_ID}:focus,
        #${RESUME_BUTTON_ID}:active {
            background: #44bb52;
            color: #fff;
        }
        #${RESUME_BUTTON_ID}.is-visible {
            display: block;
        }
        #hdv-demo-banner {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            height: ${DEMO_BANNER_HEIGHT};
            z-index: 100001;
            background: var(--background-menu);
            color: var(--fonte_menu_lateral);
            text-align: center;
            font-size: 12px;
            line-height: ${DEMO_BANNER_HEIGHT};
            padding: 0 12px;
            pointer-events: none;
            box-sizing: border-box;
        }
        body.hdv-demo-active .hdv-app-container {
            top: ${DEMO_BANNER_HEIGHT} !important;
            height: calc(100% - ${DEMO_BANNER_HEIGHT}) !important;
        }
        body.hdv-demo-active .fixed {
            top: ${DEMO_BANNER_HEIGHT} !important;
            height: calc(100% - ${DEMO_BANNER_HEIGHT}) !important;
        }
        body.hdv-demo-active .hdv-barsuper {
            top: ${DEMO_BANNER_HEIGHT} !important;
        }
        body.hdv-demo-active [data-tour^="help-"] {
            display: none !important;
        }
        body.hdv-demo-active .hdv-form-default input,
        body.hdv-demo-active .hdv-form-default select,
        body.hdv-demo-active .hdv-form-default textarea,
        body.hdv-demo-active .hdv-form-default label,
        body.hdv-demo-active .hdv-form-default [contenteditable="true"],
        body.hdv-demo-active .hdv-form-default .rs__control,
        body.hdv-demo-active .hdv-form-default .escolha-icones,
        body.hdv-demo-active #container-campo-customizado button,
        body.hdv-demo-active #container-campo-customizado .json-tree-param-btn,
        body.hdv-demo-active [data-tour$="-form-root"] input,
        body.hdv-demo-active [data-tour$="-form-root"] select,
        body.hdv-demo-active [data-tour$="-form-root"] textarea,
        body.hdv-demo-active [data-tour$="-form-root"] label,
        body.hdv-demo-active [data-tour$="-form-root"] [contenteditable="true"],
        body.hdv-demo-active [data-tour$="-form-root"] .rs__control {
            pointer-events: none !important;
        }
        body.hdv-demo-active [data-tour$="-salvar"]:not(.hdv-demo-save-unlocked) {
            pointer-events: none !important;
            opacity: 0.55 !important;
            cursor: not-allowed !important;
        }
        body.hdv-demo-active [data-tour$="-salvar"].hdv-demo-save-unlocked {
            pointer-events: auto !important;
            opacity: 1 !important;
            cursor: pointer !important;
        }
        .hdv-tour-choice-actions {
            display: flex;
            flex-direction: column;
            gap: 10px;
            margin-top: 14px;
        }
        .hdv-tour-choice-actions button {
            width: 100%;
            border: 0;
            border-radius: 8px;
            padding: 10px 14px;
            font-weight: 700;
            cursor: pointer;
            font-family: inherit;
        }
        .hdv-tour-choice-demo {
            background: #44bb52;
            color: #fff;
        }
        .hdv-tour-choice-guide {
            background: #207fcc;
            color: #fff;
        }
        .hdv-tour-choice-cancel {
            background: #e8e8e8;
            color: #454545;
        }
        .hdv-tour-nao-mostrar {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-top: 14px;
            color: #555;
            font-size: 0.88rem;
            font-weight: 600;
            cursor: pointer;
            user-select: none;
        }
        .hdv-tour-nao-mostrar input {
            margin: 0;
            cursor: pointer;
        }
        .hdv-tour-boas-vindas .hdv-tour-nao-mostrar {
            margin-top: 22px;
            font-size: 0.75rem;
            font-weight: 500;
            color: #777;
            gap: 6px;
        }
        body.hdv-demo-exit-confirm #${RESUME_BUTTON_ID} {
            display: none !important;
            pointer-events: none !important;
            visibility: hidden !important;
        }
        body.hdv-demo-exit-confirm #${EXIT_BUTTON_ID} {
            pointer-events: none !important;
            opacity: 0.55 !important;
            cursor: not-allowed !important;
        }
    `
}

export const mountDemoExitUi = ({ onExit, onResume, onRequestExit } = {}) => {
    ensureStyles()
    document.body.classList.add('hdv-demo-active')

    if (!document.getElementById('hdv-demo-banner')) {
        const banner = document.createElement('div')
        banner.id = 'hdv-demo-banner'
        banner.textContent = 'Modo demonstração ativo. Os dados desta sessão são fictícios e não serão salvos no sistema.'
        document.body.appendChild(banner)
    }

    let actions = document.getElementById(ACTIONS_ID)
    if (!actions) {
        actions = document.createElement('div')
        actions.id = ACTIONS_ID
        document.body.appendChild(actions)
    }

    let resumeButton = document.getElementById(RESUME_BUTTON_ID)
    if (!resumeButton) {
        resumeButton = document.createElement('button')
        resumeButton.id = RESUME_BUTTON_ID
        resumeButton.type = 'button'
        resumeButton.textContent = 'Retomar guia'
        actions.appendChild(resumeButton)
    }

    let exitButton = document.getElementById(EXIT_BUTTON_ID)
    if (!exitButton) {
        exitButton = document.createElement('button')
        exitButton.id = EXIT_BUTTON_ID
        exitButton.type = 'button'
        exitButton.textContent = 'Sair da demonstração'
        actions.appendChild(exitButton)
    }

    resumeButton.onclick = () => {
        if (isDemoExitConfirmActive()) return
        if (typeof onResume === 'function') onResume()
    }

    exitButton.onclick = () => {
        if (isDemoExitConfirmActive()) return
        if (typeof onRequestExit === 'function') {
            onRequestExit()
            return
        }

        showDemoExitConfirmation(onExit)
    }
}

export const showDemoExitConfirmation = (onExit, onContinue) => {
    setDemoExitConfirmActive(true)

    const clearConfirm = () => {
        setDemoExitConfirmActive(false)
    }

    document.dispatchEvent(
        new CustomEvent('showAviso', {
            detail: {
                title: 'Sair da demonstração',
                message:
                    'Deseja sair do modo demonstração? Todos os dados fictícios serão descartados e o sistema voltará ao modo normal.',
                callbackLabel: 'Sair da demonstração',
                callbackLabelClose: 'Continuar na demonstração',
                callback:
                    typeof onExit === 'function' ? () => {
                        clearConfirm()
                        onExit()
                    } : () => clearConfirm(),
                callbackClose:
                    typeof onContinue === 'function' ? () => {
                        clearConfirm()
                        onContinue()
                    } : () => clearConfirm(),
            },
        })
    )
}

export const setDemoResumeVisible = (visible) => {
    const resumeButton = document.getElementById(RESUME_BUTTON_ID)
    if (!resumeButton) return

    if (document.body.classList.contains('hdv-demo-exit-confirm')) {
        resumeButton.classList.remove('is-visible')
        resumeButton.disabled = true
        resumeButton.setAttribute('aria-disabled', 'true')
        return
    }

    resumeButton.classList.toggle('is-visible', Boolean(visible))
    resumeButton.disabled = false
    resumeButton.removeAttribute('aria-disabled')
}

export const setDemoExitConfirmActive = (active) => {
    if (active) {
        document.body.classList.add('hdv-demo-exit-confirm')
        setDemoResumeVisible(false)
        return
    }

    document.body.classList.remove('hdv-demo-exit-confirm')
}

export const isDemoExitConfirmActive = () =>
    document.body.classList.contains('hdv-demo-exit-confirm')

export const unmountDemoExitUi = () => {
    document.body.classList.remove('hdv-demo-active')
    document.body.classList.remove('hdv-demo-exit-confirm')
    document.getElementById(ACTIONS_ID)?.remove()
    document.getElementById(EXIT_BUTTON_ID)?.remove()
    document.getElementById(RESUME_BUTTON_ID)?.remove()
    document.getElementById('hdv-demo-banner')?.remove()
}

export { ensureStyles as ensureDemoUiStyles }
